import "regenerator-runtime/runtime";
import axios from 'axios';
let React = require('react');
let toastr = require('toastr');

class BackordersRequest {

    async getBackorders(requestBody){

        let APIurl = process.env.PROTOCOL + "://" + process.env.BASE_URL + "/user/plugins/" + process.env.GATEWAY_SERVICE + "/Gateway_service.php";
        
        var arrResponse = [];
        
        let config = {
            headers: {
                'Content-Type': 'application/json',
                'Accept' : "*/*"
            }
        };

        var result = {};

        let gatewayRequest = {
            "strEndpointName" : "GetBackOrder",
            "strMethod" : "POST",
            "strJsonData" : requestBody//,
            //"arrCustomHeaders": []
        }

        await axios.post(APIurl, gatewayRequest, config)
            .then(response => {
                result = JSON.parse(response.data);
                arrResponse = result.BackOrderDetails ? result.BackOrderDetails : [];
                if(result.Result !== 1){
                  //  alert(result.Message)
                    toastr.warning("Posiblemente no se encontraron registros en Backorder, para más información por favor comunícate con tu proveedor.");
                }
            })
            .catch(error => console.error(error));

            return arrResponse;       
    }
}

module.exports = BackordersRequest